import type { TFunction } from 'i18next'

import { createErrorMapRule } from '../utils/create-rule.ts'

export const invalidTypeRule = (t: TFunction<'validation'>) =>
  createErrorMapRule('invalid_type', t, (issue, context, t) => {
    const type = issue.input === undefined ? 'undefined' : 'other'
    const received = Array.isArray(issue.input)
      ? 'array'
      : issue.input === null
        ? 'null'
        : typeof issue.input

    const fieldName = issue.path[issue.path.length - 1]

    return {
      message: t(`invalid_type.${type}`, {
        field: fieldName
          ? (context.fields?.[fieldName]?.label ?? 'Field')
          : 'Field',
        expected: issue.expected,
        received,
      }),
    }
  })
